
<h1 mat-dialog-title>{{ 'support_access_dialog.title.support_access' | translate | titlecase }}</h1>

<div mat-dialog-content>

    <div class="row no-gutters mb-4">
        <div class="col-12">

            <validity-period [idPrefix]="(idPrefix + 'period.')"
                             [label]="('support_access_dialog.label.period'  | translate) + ' *'"
                             [size]="ValidityPeriodSize.SIZE_75"
                             [periods]="periods"
                             [invalid]="periodError"
                             [(selectedPeriod)]="selectedPeriod">
            </validity-period>
        </div>
    </div>


</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.accept" mat-raised-button class="full-width" color="accent" (click)="accept()">{{ 'common.btn.ok' | translate }}</button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.cancel" mat-stroked-button color="primary" class="full-width" (click)="close()">{{ 'common.btn.cancel' | translate }}</button>
    </div>

</div>
